import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, ElementRef, input, model, viewChild } from "@angular/core";

@Component({
  selector: "tabbed-detail-navigation",
  templateUrl: "tabbed-detail-navigation.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule],
})
export class TabbedDetailNavigation {
  private tabsnav = viewChild.required<ElementRef<HTMLElement>>("tabsnav");
  readonly tabs = input.required<{ title: string; subtitle: string }[]>();
  readonly activeTabIndex = model.required<number>();

  moveLeft() {
    this.activeTabIndex.update((activeTabIndex) => Math.max(0, activeTabIndex - 1));
    this.tabsnav().nativeElement.scrollLeft -= 300;
  }

  moveRight() {
    this.activeTabIndex.update((activeTabIndex) => Math.min(this.tabs().length - 1, activeTabIndex + 1));
    this.tabsnav().nativeElement.scrollLeft += 300;
  }
}
